import { type DefaultContext, mutationPromise } from '@egw/clients'
import { createMutationHook, createQueryHook } from '../../../hooks'
import {
  type EnrollmentApplicationSubmitInput,
  type EnrollmentApplicationSubmitOutput,
} from '../../../models/enrollment/application'

/**
 * Submit Enrollment Application data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentApplicationSubmitOutput>
 * @example const response = await submitEnrollmentApplicationData();
 */
export const submitEnrollmentApplicationData = async (
  enrollmentApplicationSubmitInput: EnrollmentApplicationSubmitInput,
  context?: DefaultContext,
): Promise<EnrollmentApplicationSubmitOutput> => {
  const response = (await mutationPromise(
    {
      name: 'submitEnrollmentApplicationData',
      query: `mutation submitEnrollmentApplicationData($submitEnrollmentInput: SubmitEnrollmentInput!) {
        submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
          ... on SubmitEnrollmentSuccess {
            __typename
            path
          }
          ... on SubmitEnrollmentError {
            __typename
            path
          }
        }
      }`,
    },
    {
      submitEnrollmentInput: enrollmentApplicationSubmitInput,
    },
    context,
  )) as { submitEnrollment: EnrollmentApplicationSubmitOutput }
  return response.submitEnrollment
}

export const useSubmitEnrollmentApplicationData = createMutationHook<
  EnrollmentApplicationSubmitInput,
  EnrollmentApplicationSubmitOutput
>(submitEnrollmentApplicationData)
